const getConfig = (configType, configuration) => {
  var _a;
  return (_a = configuration == null ? void 0 : configuration[configType]) != null ? _a : null;
};
const isProcessorEnabled = (processor, config) => config.disabled_processors.filter((p) => p === processor.class_name).length < 1;
export { getConfig, isProcessorEnabled };
export default getConfig;
